// extracted by mini-css-extract-plugin
module.exports = {"container":"UserNotice_container__3ZaXf","notice":"UserNotice_notice__10iX3","content":"UserNotice_content__YTLZj"};